import React, { Component, PropTypes } from 'react';
import invariant from 'invariant';
import Series from '../components/Series';
import * as library from '../lib/library';

export default class SeriesPage extends Component {
  static propTypes = {
    params: PropTypes.shape({
      seriesId: PropTypes.string,
    }).isRequired,
  };

  render() {
    const series = library.getSeriesById(this.props.params.seriesId);

    document.title = `Series: ${series.title} by Jennifer Zwick`;

    const works = series.works.map((id) => {
      const work = library.getWorkById(id);
      invariant(work, `Work "${id}" does not exist, from the series "${series.id}".`);
      return work;
    });

    return <Series series={series} works={works} />;
  }
}



// WEBPACK FOOTER //
// ./application/js/pages/SeriesPage.js